import React, {useCallback, useState, useContext, useEffect} from 'react';
import {Popup, Textarea, Button, Select, setOptions, toast as mbToast} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import '../styles/dashboardWorkspaceGenerate.css';
import {NetworkContext} from "../utils/NetworkContext";
import Empty from "../utils/Empty";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/pro-duotone-svg-icons";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboardWorkspaceGenerate({Dialog, dialog, locale, setToast, toast, width, setWorkspaceItemDialog, user, navigation, teamtalk}) {
    const {wsCall, wsResponse, setWsResponse} = useContext(NetworkContext);
    const [image, setImage] = useState({});
    const [prompt, setPrompt] = useState(null);
    const [negative, setNegative] = useState(null);
    const [size, setSize] = useState(locale.dashboardWorkspaceGenerate.m[0].value);
    const [quality, setQuality] = useState(locale.dashboardWorkspaceGenerate.l[0].value);
    const [background, setBackground] = useState(locale.dashboardWorkspaceGenerate.n[0].value);
    const [format, setFormat] = useState(locale.dashboardWorkspaceGenerate.k[0].value);
    const [compression, setCompression] = useState(locale.dashboardWorkspaceGenerate.p[0].value);
    const [moderation, setModeration] = useState(locale.dashboardWorkspaceGenerate.r[0].value);
    const [model, setModel] = useState(locale.dashboardWorkspaceGenerate.t[0].value);

    const DialogClose = useCallback(() => {
        Dialog({view: 'close'});
    }, [Dialog]);

    const ButtonGenerate = () => {
        if (!Empty(image)) {
            setImage({});
        } else if (Empty(image) && !prompt) {
            toast({message: locale.dashboardWorkspaceGenerate.a, color: 'danger', display: 'bottom', duration: 3000});
        } else if (Empty(image) && prompt) {
            setToast({message: locale.dashboardWorkspaceGenerate.g, color: 'primary', display: 'center', duration: false});
            setImage('');

            const message = {
                type: 'wss',
                path: 'image',
                action: 'get',
                data: {
                    prompt: prompt,
                    size: size,
                    quality: quality,
                    background: background,
                    format: format,
                    compression: compression,
                    moderation: moderation,
                    model: model,
                    negative: negative,
                    tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab,
                    teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id} : null,
                }
            };
            wsCall(message);
        }
    }

    const SelectCompression = data => {
        if (data !== '100' && format !== 'jpeg') {
            setFormat('jpeg');
        }
        setCompression(data);
    }

    const ButtonWorkspace = () => {
        const item = {...image};
        item.type = 'file';
        setWorkspaceItemDialog(item);
        Dialog({view: 'dashboardWorkspaceAddName'});
    }

    const GetImage = useCallback(data => {
        if (data.image) {
            setImage(data.image);
        }
        if (data.error) {
            mbToast({message: data.error, color: 'danger', display: 'bottom', duration: 5000});
        }
    }, []);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'image') {
            GetImage(wsResponse.data);
            setWsResponse({});
            setToast({});
        }
    }, [wsResponse, GetImage, setWsResponse]);

    return (
        <Popup className="cs-dashboard-workspace-generate-popup" maxHeight={750} closeOnOverlayClick={false} closeOnEsc={false} scrollLock={false} display="center" width="600" buttons={[]} isOpen={dialog.view === 'dashboardWorkspaceGenerate'} onClose={DialogClose} >
            <div className="mbsc-grid cs-dashboard-workspace-generate-header-col">
                <div className="mbsc-row cs-dashboard-workspace-generate-header-row">
                    {width > 576 &&
                        <div className="mbsc-col cs-dashboard-workspace-generate-header-col" />
                    }
                    <div className={width > 576 ? "mbsc-col cs-dashboard-workspace-generate-header-col mbsc-align-center" : "mbsc-col cs-dashboard-workspace-generate-header-col"} >
                        <Button className="cs-dashboard-workspace-generate-title-button mbsc-bold mbsc-txt-muted" variant="flat" >
                            {locale.dashboardWorkspaceGenerate.c}
                        </Button>
                    </div>
                    <div className="mbsc-col cs-dashboard-workspace-generate-header-col mbsc-align-right">
                        <Button disabled={!Empty(toast)} color="primary" variant="flat" className="mbsc-bold cs-dashboard-workspace-generate-close-button" onClick={() => DialogClose()} >
                            &nbsp;<FontAwesomeIcon className="cs-dashboard-workspace-generate-close-icon" icon={faXmark} />
                        </Button>
                    </div>
                </div>
            </div>
            <div className="cs-dashboard-workspace-generate-helper">
                <p>{locale.dashboardWorkspaceGenerate.e}</p>
            </div>
            <div className="cs-dashboard-workspace-generate-textarea">
                <Textarea
                    disabled={!Empty(image)}
                    inputStyle="underline"
                    labelStyle="floating"
                    rows={3}
                    value={prompt}
                    onChange={(ev) => setPrompt(ev.target.value)}
                />
            </div>
            {model && model.includes('qwen') &&
                <Textarea
                    label={locale.dashboardWorkspaceGenerate.v}
                    disabled={!Empty(image)}
                    inputStyle="underline"
                    labelStyle="floating"
                    rows={1}
                    value={negative}
                    onChange={(ev) => setNegative(ev.target.value)}
                />
            }
            {Empty(image) &&
                <Select
                    animation="slide-down"
                    inputStyle="underline"
                    label={locale.dashboardWorkspaceGenerate.u}
                    labelStyle="floating"
                    rows={locale.dashboardWorkspaceGenerate.t.length}
                    display="anchored"
                    touchUi={false}
                    data={locale.dashboardWorkspaceGenerate.t}
                    value={model}
                    onChange={args => setModel(args.value)}
                />
            }
            {!Empty(image) &&
                <div style={{backgroundImage: `url(${"data:" + image.mime + ";base64," + image.file})`}} className="cs-dashboard-workspace-generate-image"  />
            }
            {Empty(image) &&
                <Select
                    animation="slide-down"
                    inputStyle="underline"
                    label={locale.dashboardWorkspaceGenerate.f}
                    labelStyle="floating"
                    rows={locale.dashboardWorkspaceGenerate.m.length}
                    display="anchored"
                    touchUi={false}
                    data={locale.dashboardWorkspaceGenerate.m}
                    value={size}
                    onChange={args => setSize(args.value)}
                />
            }
            {Empty(image) && !model.includes('qwen') &&
                <Select
                    animation="slide-down"
                    inputStyle="underline"
                    label={locale.dashboardWorkspaceGenerate.i}
                    labelStyle="floating"
                    rows={locale.dashboardWorkspaceGenerate.l.length}
                    display="anchored"
                    touchUi={false}
                    data={locale.dashboardWorkspaceGenerate.l}
                    value={quality}
                    onChange={args => setQuality(args.value)}
                />
            }
            {Empty(image) && !model.includes('qwen') &&
                <Select
                    animation="slide-down"
                    inputStyle="underline"
                    label={locale.dashboardWorkspaceGenerate.d}
                    labelStyle="floating"
                    rows={locale.dashboardWorkspaceGenerate.n.length}
                    display="anchored"
                    touchUi={false}
                    data={locale.dashboardWorkspaceGenerate.n}
                    value={background}
                    onChange={args => setBackground(args.value)}
                />
            }
            {Empty(image) && !model.includes('qwen') &&
                <Select
                    animation="slide-down"
                    inputStyle="underline"
                    label={locale.dashboardWorkspaceGenerate.j}
                    labelStyle="floating"
                    rows={locale.dashboardWorkspaceGenerate.k.length}
                    display="anchored"
                    touchUi={false}
                    data={locale.dashboardWorkspaceGenerate.k}
                    value={format}
                    onChange={args => setFormat(args.value)}
                />
            }
            {Empty(image) && !model.includes('qwen') &&
                <Select
                    animation="slide-down"
                    inputStyle="underline"
                    label={locale.dashboardWorkspaceGenerate.o}
                    labelStyle="floating"
                    rows={locale.dashboardWorkspaceGenerate.p.length}
                    display="anchored"
                    touchUi={false}
                    data={locale.dashboardWorkspaceGenerate.p}
                    value={compression}
                    onChange={args => SelectCompression(args.value)}
                />
            }
            {Empty(image) && !model.includes('qwen') && user.options.superAdmin &&
                <Select
                    animation="slide-down"
                    inputStyle="underline"
                    label={locale.dashboardWorkspaceGenerate.q}
                    labelStyle="floating"
                    rows={locale.dashboardWorkspaceGenerate.r.length}
                    display="anchored"
                    touchUi={false}
                    data={locale.dashboardWorkspaceGenerate.r}
                    value={moderation}
                    onChange={args => setModeration(args.value)}
                />
            }
            <div className="mbsc-button-group-justified cs-dashboard-workspace-generate-nav-buttons">
                <Button disabled={Empty(image)} color="primary" variant="flat" className="mbsc-bold cs-dashboard-workspace-generate-nav-button" onClick={() => ButtonWorkspace()} >
                    {locale.dashboardWorkspaceGenerate.h}
                </Button>
                <Button disabled={!Empty(toast)} color="primary" variant="flat" className="mbsc-bold cs-dashboard-workspace-generate-nav-button" onClick={() => ButtonGenerate()} >
                    {Empty(image) ? locale.dashboardWorkspaceGenerate.b : locale.dashboardWorkspaceGenerate.s}
                </Button>
            </div>
        </Popup>
    );
}

export default DashboardWorkspaceGenerate;
